module.exports = __webpack_public_path__ + "img/planet-mercury.13e97ecb.svg";